import { Box, Button, Typography } from "@mui/material";
import React from "react";
import PersonIcon from "@mui/icons-material/Person";

function PlanCard({ title, price, duration, contactsAllowed, styles ,discount,durationType}) {
	// Package plan component
	return (
		<Box
			sx={{
				border: "1px solid #c9a05f",
				borderRadius: "10px",
				padding: { xs: 2, md: 3 },
				display: "flex",
				flexDirection: "column",
				height: { xs: "auto", md: "261px" },
				width: { xs: "100%", sm: "260px", md: "303px" },
				margin: { xs: "0 auto", md: 0 },
				maxWidth: "100%",
			}}
		>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					mb: 4,
				}}
			>
				<Typography variant="h6" component="div" sx={{...styles,fontSize:{xs:'16px',sm:'20px'}}}>
					{title}
				</Typography>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						backgroundColor: "#f8e9c8",
						borderRadius: "15px",
						padding: "2px 8px",
					}}
				>
					<PersonIcon sx={{ fontSize: "0.9rem", mr: 0.5, color: "#8a6d3b" }} />
					<Typography
						variant="body2"
						sx={{ color: "#8a6d3b",fontSize:{xs:'16px',sm:"0.9rem"}
					}}
					>
						{contactsAllowed}
					</Typography>
				</Box>
			</Box>

			<Typography
				variant="body2"
				sx={{
					...styles,
					fontSize: 20,
					fontWeight: 500,
					mb: 1,
				}}
			>
			</Typography>

			<Box sx={{ mb: 2, width: "100%" }}>
				<Typography component="span" variant="h6" sx={{...styles,fontSize:{xs:'16px',sm:'20px'}}}>
					₹ {price} /
				</Typography>
				<Typography
					component="span"
					variant="body2"
					sx={{ ...styles, color: "#908C8C" ,fontSize:{xs:'16px',sm:'20px'}
				}}
				>
					{" " + duration}
				</Typography>
				<Typography component='span'sx={{ml:1,
									fontSize:{xs:'16px',sm:'20px'}

				}}>
				{durationType}
				</Typography>
			</Box>
			<Typography variant="h6" component="div" sx={{mb:1,
				fontSize:{xs:'16px',sm:'20px'}
			}}>
					Discount {discount} Off Now
				</Typography>
			<Button
				variant="contained"
				sx={{
					backgroundColor: "#f8e9c8",
					color: "#000000",
					fontWeight: "bold",
					borderRadius: "20px",
					textTransform: "none",
		
					"&:hover": {
						backgroundColor: "#e5d6b5",
					},
				}}
			>
				Buy Now
			</Button>
		</Box>
	);
}

export default PlanCard;
